import {
  AccountCircle,
  Add,
  Bookmark,
  BookmarkAddOutlined,
  Create,
  Dashboard,
  Delete,
  Diamond,
  EventRepeat,
  FormatPaint,
  Launch,
  Lock,
  LogoutOutlined,
  OpenInFull,
  Visibility,
} from '@mui/icons-material';
import { IconId } from '@src/main/ui/components/common/Icon/IconId';
import Airline from '@src/main/ui/components/common/Icon/custom/Airline';
import Areas from '@src/main/ui/components/common/Icon/custom/Areas';
import CentralServices from '@src/main/ui/components/common/Icon/custom/CentralServices';
import Close from '@src/main/ui/components/common/Icon/custom/Close';
import Handling from '@src/main/ui/components/common/Icon/custom/Handling';
import Home from '@src/main/ui/components/common/Icon/custom/Home';
import Iberia from '@src/main/ui/components/common/Icon/custom/Iberia';
import IberiaDark from '@src/main/ui/components/common/Icon/custom/IberiaDark';
import Info from '@src/main/ui/components/common/Icon/custom/Info';
import MRO from '@src/main/ui/components/common/Icon/custom/MRO';
import Search from '@src/main/ui/components/common/Icon/custom/Search';
import { ReactNode } from 'react';

export const useGetIcon = (icon: IconId): ReactNode => {
  switch (icon) {
    case 'add': {
      return <Add />;
    }
    case 'home': {
      return <Home />;
    }
    case 'search': {
      return <Search />;
    }
    case 'favorites-outlined': {
      return <BookmarkAddOutlined fontSize="inherit" />;
    }
    case 'favorites': {
      return <Bookmark fontSize="inherit" />;
    }
    case 'areas': {
      return <Areas />;
    }
    case 'airline': {
      return <Airline />;
    }
    case 'mro': {
      return <MRO />;
    }
    case 'handling': {
      return <Handling />;
    }
    case 'central-services': {
      return <CentralServices />;
    }
    case 'iberia': {
      return <Iberia />;
    }
    case 'iberia-dark': {
      return <IberiaDark />;
    }
    case 'close': {
      return <Close />;
    }
    case 'certified': {
      return <Diamond fontSize="inherit" />;
    }
    case 'delete': {
      return <Delete fontSize="inherit" />;
    }
    case 'edit': {
      return <Create fontSize="inherit" />;
    }
    case 'lock': {
      return <Lock fontSize="inherit" />;
    }
    case 'info': {
      return <Info />;
    }
    case 'views': {
      return <Visibility fontSize="inherit" />;
    }
    case 'refreshDate': {
      return <EventRepeat fontSize="inherit" />;
    }
    case 'launch': {
      return <OpenInFull fontSize="inherit" />;
    }
    case 'open-external': {
      return <Launch fontSize="inherit" />;
    }
    case 'account': {
      return <AccountCircle fontSize="inherit" />;
    }
    case 'none': {
      return <Dashboard fontSize="inherit" />;
    }
    case 'logout': {
      return <LogoutOutlined fontSize="inherit" />;
    }
    case 'theme': {
      return <FormatPaint fontSize="inherit" />;
    }
    default:
      return <span />;
  }
};
